import { Card } from '@ahafood/ui/components/card';
import { Skeleton } from '@ahafood/ui/components/skeleton';

const SKELETON_COUNT = 4;

export default function InlineLoadingSkeletons() {
  return Array.from({ length: SKELETON_COUNT }, (_, i) => (
    <Card
      key={i}
      className="size-full overflow-hidden bg-white flex flex-col border-none"
    >
      <div className="relative w-full aspect-square">
        <Skeleton className="size-full rounded-lg bg-neutral-10" />
        <div className="absolute bottom-0 left-0">
          <Skeleton className="h-5 w-20 rounded-tr-2xl bg-neutral-10" />
        </div>
      </div>

      <div className="py-2 flex flex-col gap-1 flex-1">
        <Skeleton className="h-4 w-full bg-neutral-10" />
        <div className="flex justify-between border-b pb-2 mt-auto">
          <Skeleton className="h-6 w-16 bg-neutral-10" />
          <Skeleton className="h-8 w-12 rounded-xl bg-neutral-10" />
        </div>
        <div className="flex justify-between mb-1">
          <Skeleton className="h-3 w-2/3 bg-neutral-10" />
          <Skeleton className="h-3 w-8 bg-neutral-10" />
        </div>
        <Skeleton className="h-5 w-full bg-neutral-10" />
      </div>
    </Card>
  ));
}
